import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mapToIterable' })
export class MapToIterable implements PipeTransform {
    transform(map: { [key: string]: any }, ...parameters: any[]) {
        if (!map)
            return undefined;
		return Object.keys(map).sort(function (a, b) {
			return a.toLowerCase().localeCompare(b.toLowerCase());
		})
        .map((key) => ({ 'key': key, 'value': map[key] }));
    }
}
//https://stackoverflow.com/questions/31490713/iterate-over-object-in-angular